export const fi = {
  ADD_COLOR_STRING_KEY: 'Add color',
  ADD_TEXT_KEY: 'Lisää tekstiä',
  ADD_TO_ORDER_KEY: 'Add to order',
  ADD_TO_CART: 'Lisää ostoskoriin',
  ADD_TEMPLATE: 'Add Template',
  ADJUST_SIZE_KEY: 'Adjust Size',
  ADJUST_TRANSPARENCY_KEY: 'Adjust Transparency',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    "By clicking Done, you agree to the HP's terms of use and privacy statement.",
  ALIGN_BOTTOM_KEY: 'joondage alumine',
  ALIGN_CENTER_KEY: 'kohdista keskus',
  ALIGN_KEY: 'kohdistaa',
  ALIGN_LEFT_KEY: 'Align Left',
  ALIGN_MIDDLE_KEY: 'kohdista keskelle',
  ALIGN_RIGHT_KEY: 'Align Right',
  ALIGN_TOP_KEY: 'Joondage top',
  ALL_TAB_TITLE_KEY: 'Kaikki',
  ALMOST_DONE_TITLE_KEY: 'Almost done!',
  AND_KEY: 'and',
  APPLY_KEY: 'Apply',
  AREA_CODE: 'Area code',
  BASIC_HELPER_INSTRUCTION1_KEY:
    'Browse the content and select the images for your design, or upload your own',
  BASIC_HELPER_INSTRUCTION2_KEY:
    'Preview your design, or fine-tune the details',
  BASIC_HELPER_INSTRUCTION3_KEY:
    'Customize the design and add other elements to your project',
  BASIC_HELPER_INSTRUCTION4_KEY:
    'When the design is ready, click NEXT to make a final check and place your order.',
  BACK_KEY: 'Back',
  BACKGROUND_KEY: 'Tausta',
  BACKGROUND_UPPER_CASE_KEY: 'BACKGROUND',
  BACKGROUND_CONTRAST_KEY: 'Background Contrast',
  BLANK_INSPIRATION_CATEGORY_KEY: 'Ei tähän luokkaan kuuluvia inspiraatioita',
  BRING_TO_FRONT_KEY: 'Tuo eteen',
  CANCEL_TEXT_KEY: ' Peruuta',
  CENTIMETERS_KEY: 'senttimetriä',
  CM_KEY: 'cm.',
  CHANGE_YOUR_SETTINGS_KEY: 'Change your project settings',
  CHECKBOX_CONTENT1: 'I want to receive the Pattern Design© newsletter',
  CHECKBOX_CONTENT2:
    'I authorize HP to create an account in Pattern Design© services on my behalf',
  CHOOSE_FROM_COMPUTER_KEY: 'Choose from computer',
  CHOOSE_RIP_OPTIONS: 'Choose one of these compatible third party RIPs',
  CHOOSE_FILE_KEY: 'Valitse tiedosto',
  CITY: 'City',
  CLEAR_ALL_KEY: 'Tyhjennä kaikki',
  CLEAR_COLOR_KEY: 'Tyhjennä väri',
  CLOSE_WINDOW_KEY: 'Sulje ikkuna',
  CLEAR_ALL_OBJECTS: 'Tyhjennä kaikki objektit',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE:
    'Tämä poistaa kaikki objektit taustaltasi.',
  CLEAR_DESIGN_KEY: 'Clear design',
  COLOR_KEY: 'Väri',
  CONTINUE_KEY: 'Jatka...',
  COMPANY: 'Company',
  CONGRATULATIONS_KEY: 'Congratulations!',
  CONFIRM_PASSWORD: 'Confirm password',
  CONFIRM_PATTERN_ACCOUNT_KEY: "Don't have a Pattern Design account yet?",
  CONFIRM_VECTEEZY_ACCOUNT_KEY: "Don't have a Vecteezy account yet?",
  COUNTRY: 'Country',
  CREATE_ACCOUNT: 'Create account',
  COPYRIGHT_YEAR_KEY: '© 2013-{0} HPDC, L.P.',
  CUSTOM_KEY: 'Custom',
  CUSTOM_PRICE_SIGN_IN_KEY: 'Sign-in in the next step to see custom pricing.',
  CM_UNIT_KEY: 'cm',
  CREATE_NEW: 'Create new',
  DESIGN_KEY: 'Suunnittelu',
  DELETE_KEY: 'Poista',
  DOCUMENT_COLORS: 'Asiakirjan värit',
  DONE: 'Done!',
  DONE_KEY: 'Valmis',
  DONT_SHOW_ALERT_KEY: "Don't show again",
  DOWNLOAD_COLUMN_HEADER_KEY: 'Lataa palvelusta',
  DOWNLOAD_APP_TITLE_KEY: 'Voit ladata sovelluksen täältä:',
  DOWNLOAD_LINK_KEY: 'Download HP Click for free here',
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DOWNLOAD_INSTR_KEY: 'Make sure you have HP Click installed before continuing',
  DOWNLOAD_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'Dropbox-tuonti',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    'The image size should be less than 1 GB. We accept pdf, png, jpg, svg and tiff formats.',
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'Dreamstime-haku',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'Dreamstime-kuvat',
  DUPLICATE_KEY: 'Kopioi',
  EACH_ITEM_PRICE_KEY:
    'Your design includes content from one of our premium content providers. The itemized pricing of each element is summarized below.',
  EDIT_DESIGN_BUTTON_TITLE_KEY: 'Muokkaa',
  EDIT_LOWERCASE_KEY: 'edit',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT:
    ' Valitettavasti tapahtui virhe. Yritä myöhemmin uudelleen.',
  ERROR_IN_OPENING_PDF_FILE_TEXT:
    'Ladatun PDF-tiedoston avaamisessa tapahtui virhe.',
  EMAIL_KEY: 'Sähköposti',
  EMAIL_ADDRESS_KEY: 'Sähköpostiosoite:',
  EMAIL_CHECKBOX_MESSAGE:
    'Tiedän tämän henkilön ymmärtävän, että hän saa HP:lta sähköpostia puolestani tai palveluntarjoajan puolesta.',
  EXTRA_INFO_KEY: 'Lisätiedot',
  EMAIL_NOTIFICATION:
    'Saat pian sähköpostiviestin. Käsittely saattaa kestää 15 minuuttia.',
  EMAIL_DIALOG_MESSAGE:
    'Kirjoita sen henkilön sähköpostiosoite, jolle haluat lähettäää suunnitelmasi.',
  ENTER_KEY: 'Enter',
  EXISTING_FOLDER_KEY: 'Olemassa oleva kansio',
  FACEBOOK_KEY: '  Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    'Ennen kassalle jatkamista varmista, että olet tehnyt oikeat valinnat.',
  FINAL_CHECK_TITLE_KEY: 'Lopullinen tarkastus',
  FINISH_KEY: 'Valmis',
  FINISH_LATER_KEY: 'Finish later',
  FIRSTNAME: 'First name',
  FISCAL_NUM: 'Fiscal number',
  FLIP_KEY: 'Käännä',
  FOR_KEY: 'varten',
  FORGOT_PASSWORD_KEY: 'Forgot password?',
  FOTOLIA_KEYWORDS_KEY: 'Avainsanat:',
  FOLDER_NAME: 'Kansion nimi',
  FOLDER_NAME_KEY: 'Kansion nimi:',
  FOLDER_ALREADY_EXIST_KEY: 'Tämän niminen kansio on jo olemassa',
  FREE_POSTER_COMPLETE_MESSAGE_KEY:
    "You've just completed your free poster design",
  FREE_VECTOR_GRAPHICS_KEY: 'free vector graphics',
  GETTY_IMAGE_SEARCH_TITLE: 'Getty Image Search',
  GOT_IT_MESSAGE_KEY: 'Ok, I got it',
  GROUP_ALL_KEY: 'Ryhmitä kaikki',
  GROUP_SCALE: 'Skaalaa ryhmää',
  GIFT_WRAPS_KEY: 'Gift Wraps',
  GIVE_PROJECT_NAME_KEY: 'Anna projektille nimi',
  HEIGHT_KEY: 'Korkeus',
  HELP_DESCRIPTION_KEY:
    'Let us walk you through the design process. Remember you can open the tour as many times as you want by clicking on the help icon.',
  HELP_KEY: 'Ohje',
  HELPER_TITLE_KEY_1:
    'Create poster designs from a blank page or from millions of images and text. Upload your own content from local drives, Dropbox or social media',
  HELPER_TITLE_KEY_3: 'See all your design work in one place',
  HELPER_TITLE_KEY_4: 'Click Next to preview and finish your final design',
  HERE_KEY: 'here',
  HELP_IMPROVE_KEY:
    'Help improve your productivity and operator efficiency, and expand with color production.',
  HIGH_QUALITY_KEY: 'High-quality',
  IMAGES_TITLE_KEY: 'KUVAT',
  IMPERIAL_KEY: 'Imperial',
  IMPORTING_KEY: 'Tuodaan',
  INCHES_COLUMN_HEADER_KEY: 'tuumaa',
  INCHES_KEY: ' tuumaa',
  INCHES_UNIT_STRING_KEY: 'tuumaa.',
  INVALID_EMAIL_ADDRESS_KEY: 'Virheellinen sähköpostiosoite',
  INVALID_INFO_KEY: 'Syötä tiedot.',
  INVALID_NAME_KEY: 'Virheellinen nimi',
  INVALID_PRINTER_MODEL_KEY: 'Invalid printer model',
  INVALID_SERIAL_NUMBER_KEY: 'Invalid serial number',
  INAVLID_USER_TYPE_KEY: 'Invalid user type',
  INVALID_FILE_SIZE_ERROR_TEXT:
    'Valitsemasi tiedosto on liian suuri. Tiedoston enimmäiskoko on 500 Mt.',
  INSUFFICIENT_CREDITS_KEY: 'Insufficient credits',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: 'Inspiration',
  I_STOCK_SEARCH_TITLE: 'iStock Search',
  INVALID_FILETYPE_ERROR_TEXT:
    'Tämä ei ole sallittu tiedostomuoto. Voimme käsitellä vain pdf-, jpg-, png-, svg- ja tif-tiedostoja.',
  LANDSCAPE_KEY: 'Landscape',
  LANGUAGE_LABLE_KEY: 'Kieli',
  LASTNAME: 'Last name',
  LEARN_MORE: 'Lisätietoja',
  LEARN_THE_BASICS_KEY: 'Learn the basics',
  LEGAL_FOOTER_MESSAGE1_KEY:
    'Käyttämällä tätä sivustoa hyväksyt seuraavat ehdot:',
  LEGAL_FOOTER_MESSAGE2_KEY: 'Verkkosivusto noudattaa seuraavia ehtoja:',
  LEGAL_FOOTER_MESSAGE3_KEY: 'ja',
  LENGTH_STRING_IN_INCHES_KEY: 'tuumaa',
  LINKED_IN_KEY: '  LinkedIn',
  LINKLABEL_TITLE_KEY: 'change',
  LINK_READER_APP_KEY: 'LinkReader App',
  LINK_READER_APP_DESCRIPTION_KEY:
    'Voit visualisoida lataamasi sisällön lataamalla LinkReader-sovelluksen.',
  LOADING_KEY: 'Ladataan...',
  LOADING_TEMPLATE_KEY: 'Loading template',
  LOGIN_NOW: 'Login now',
  LOCK_KEY: 'Lukitse',
  LOGIN_KEY: 'Kirjaudu',
  LOGIN_PATTERN_DESIGN_KEY: 'Login to Pattern design',
  LOGIN_SUBTITLE_KEY: 'Login to see customized pricing and payment details',
  LOGIN_VECTEEZY_KEY: 'Login to Vecteezy',
  LOGIN_DREAMSTIME_KEY: 'Kirjaudu Dreamstimeen',
  LOGOUT_KEY: 'Kirjaudu ulos',
  MATERIAL_TITLE_KEY: 'MATERIAALI',
  MATERIAL_STRING_KEY: 'Materiaali',
  MEASUREMENT_KEY: 'Measurement',
  METRIC_KEY: 'Metric',
  MINIMUM_ZOOM_WARNING:
    'Tätä taustaa ei voi pienentää enempää, koska olet saavuttanut seinän peittämiseen tarvittavan vähimmäiskorkeuden tai -leveyden.',
  MOBILE: 'Mobile',
  MODEL_TITLE_KEY: 'Malli',
  MORE_INFO_TEXT_KEY: 'Lisätietoja',
  MY_GIFTWRAPS_KEY: 'My Gift Wraps',
  MY_WORK_KEY: 'My work',
  MY_WORK_SAVE_KEY: 'Your design has been saved to your My Work space',
  NAME_KEY: 'Nimi:',
  NEXT_BUTTON_TITLE_KEY: 'SEURAAVA',
  NEW_FOLDER_KEY: 'Uusi kansio',
  NO_SHADOW_KEY: 'Ei varjoa',
  OBJECT_QUANTITY_KEY: 'Quantity',
  OBJECTS_UPPER_CASE_KEY: 'OBJECTS',
  OK_KEY: 'OK',
  ORDER_SAMPLE_KEY: 'Tilaa näyte',
  ORDER_SAMPLE: 'Tilaa näyte',
  ORDER_SAMPLE_INFOLABEL_1:
    'Valitse kuvasta kappale, jonka haluat tilata näytteenä',
  ORDER_SAMPLE_INFOLABEL_2:
    'Saat lähikuvan projektistasi oikeassa koossa sähköpostitse',
  ORDER_SAMPLE_INFOLABEL_3:
    'Tämä auttaa sinua arvioimaan sen laatua ja resoluutiota',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: 'Tilaa näyte heti',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    'Pyydä lähikuva projektistasi oikeassa koossa sähköpostitse voidaksesi arvioida sen laatua/tarkkuutta.',
  ORIENTATION_KEY: 'Orientation',
  OTHER_PRINTING_OPTIONS: 'Other printing options',
  PASSWORD_KEY: 'Salasana',
  PATTERN_COLOR_KEY: 'Pattern Color',
  PATTERN_DESIGN_TITLE_KEY: 'Pattern Design',
  PATTERNS_FOR_KEY: 'patterns for',
  PDF_GENERATION_ERROR_MESSAGE_KEY: 'Failed to generate pdf. Please try again.',
  PHOTOS_KEY: 'PHOTOS',
  PHOTO: 'photo',
  PHONE: 'Phone',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY:
    'Omistan tämän kuvan käyttöoikeudet ja hyväksyn',
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    'The image size should be less than 500 MB. We accept png, jpg, tiff, svg and pdf formats.',
  PIXEL_COLUMN_HEADER_KEY: 'Pikseliä',
  PININTEREST_KEY: '  Pinterest',
  PLACEHOLDER_CM_STRING_KEY: 'cm',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: 'Enter text here...',
  PLACEHOLDER_EXTRA_INFO_KEY:
    'Kerro tulostuspalvelun tarjoajalle muutama tärkeä tieto.',
  PLACEHOLDER_INCHES_STRING_KEY: 'tuumaa',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: 'My Poster',
  PORTRAIT_KEY: 'Portrait',
  POSITION: 'Sijainti',
  PREMIUM_IMAGES_TITLE_KEY: 'Premium images:',
  PRE_CHECK_SAVE_DIALOG_TITLE: 'Tallenna projekti',
  PRE_CHECK_SAVE_DIALOG_MESSAGE:
    'Projektiin on tehty muutoksia, jotka pitää tallentaa ennen jatkamista.',
  PRICE_COLUMN_HEADER_KEY: 'Hinta',
  PRINTER_SERIAL_NUMBER_KEY: 'Printer serial number*',
  PRINTING_ENABLE_DETAILS_KEY:
    'To enable printing we just need a few more details',
  PRINTER_MODELS_KEY: 'Printer models*',
  PROCESSING_KEY: 'Käsitellään...',
  PROCESSING_ALERT_TXT:
    'Do not close this window while we are processing your design',
  PROCESSING_ALERT_TXT2:
    'Once processing has been completed, HP Click will open automatically and start downloading your file',
  PROCESSING_DONE: 'You are almost done!',
  PROCESSING_FILE_TXT: 'Your file is being processed.',
  PROCESSING_TIME_TXT:
    'This may take some time as we are composing your creation to ensure the best image quality',
  PROCESSING_ALERT_TXT3:
    'Your PDF will be automatically downloaded to your computer',
  PROCESSING_ALERT_TXT4:
    'Remember you can configure your JDF connection for automation in settings',
  PREMIUM_CONTENT_KEY: 'Premium Content',
  PREVIEW_KEY: 'Esikatselu',
  PROFESSIONAL_USE_TITLE_KEY: 'professional use.',
  PROJECT_NAME_KEY: 'Projektin nimi',
  PROJECT_NAME: 'Projektin nimi:',
  PROJECT_ALREADY_EXIST_KEY: 'Tämän niminen projekti on jo olemassa',
  NONUNIQUE_PROJECT_NAME_MESSAGE: 'Tämän niminen projekti on jo olemassa',
  NONUNIQUE_FOLDER_NAME_MESSAGE: 'Tämän niminen kansio on jo olemassa',
  PIXELATION_WARNING_KEY: 'Pikselöitymisvaroitus',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    'Lataamasi valokuvan tarkkuuden vuoksi ihosi voi olla vääristynyt tai vääristynyt. Varmista, että epäterävyyttä ei ole, lataamalla laadukas kuva ja vältä kuvan venyttämistä. Jos olet tyytyväinen esikatseluun ja haluat jatkaa, jatka lähettämistä.',
  REGISTER_CONTACTINFO: 'Contact information',
  REGISTER_INFO: 'Register information',
  REGISTER_PATTERNSUB1: 'As a value HP customer,',
  REQUIRED_FIELDS_KEY: 'Required fields',
  REQUIRED_FIELDS_TEXT_KEY: 'Required fields',
  REQUIRED_STRING_KEY: 'PAKOLLINEN',
  RECOLOR_KEY: 'Muuta värejä',
  RADICALLY_SIMPLE_KEY: 'Radically simple printing software',
  RIPSELECTION_HEAD:
    'This is your first time, select your prefered compatible printing software',
  RIPSELECTION_DESC:
    'Your selection will become your default printing option path for future print outs. Changes can be made later in settings',
  REGISTER_COMPANYINFO: 'Company information',
  REGISTER_KEY: 'Register',
  REGISTER_NOW: 'Register now',
  REOLOR_KEY: 'Muuta värejä',
  REQUEST_SAMPLE_KEY: 'Tilaa näyte',
  RESIZE_KEY: 'Resize',
  RESIZE_ARBITRARILY_KEY: 'Resize Arbitrarily',
  RESIZE_PROPORTIONALLY_KEY: 'Resize Proportionally',
  REVIEW_AND_SUBMIT_KEY: 'Review and Submit',
  REQUEST_FOR_QUOTATION: 'Hintatarjouspyyntö',
  RIGHT_LOGO_TEXT_KEY: 'suunnittelija',
  ROTATE_KEY: 'Kierrä',
  ROTATE_LEFT_KEY: 'Kierrä 90° vasempaan',
  ROTATE_RIGHT_KEY: 'Kierrä 90° oikeaan',
  ROTATION_KEY: 'Kierto',
  ROWS_COLUMN_LABEL_STRING_KEY: 'Rivit ja sarakkeet',
  ROYALTY_FREE_KEY: 'royalty-free',
  ROYALTY_KEY: 'royalty',
  SALUTATION: 'Salutation',
  SAVE_KEY: 'Tallenna',
  SAVING_KEY: 'Tallennetaan...',
  SAVE_INSPIRATION: 'Save inspiration',
  SAVE_TEMPLATE: 'Save template',
  SAVE_DIALOG_TITLE: 'Tallenna projekti',
  SAVE_PROJECT_NAME_KEY: 'Tallenna projekti ensin',
  SAVEDIALOG_MESSAGE:
    'Kirjaudu sisään tallentaaksesi projektisi. Jos sinulla ei ole käyttäjätiliä, autamme sinua luomaan tilin. Et menetä tekemääsi työtä.',
  SEAMLESS_KEY: 'seamless',
  SCALE_INFO_STRING_KEY: 'Scale the image to fit with on your design',
  SCALE_KEY: 'Skaalaa',
  SCALE_ALL_KEY: 'Skaalaa kaikki',
  SCALE_TO_FILL_KEY: 'Scale To Fill',
  SEARCH_BUTTON_TITLE_KEY: 'Haku',
  SELECT_CUSTOM_SIZE_KEY: 'Select custom size',
  SELECT_CUSTOM_KEY: 'Custom',
  SEARCH_TITLE: 'Haku',
  SELECTED_IMAGE_KEY: ' Selected Image: ',
  SELECT_GIFT_WRAPS_SIZE_KEY: 'Select Gift Wraps size',
  SELECT_COUNTRY: 'Select Country',
  SELECT_SALUTATION: '---Select---',
  SELECT_POSTER_SIZE_KEY: 'Select poster size',
  SELECT_PRINTING_OPTION_KEY: 'Select your prefered printing option',
  SEND_INSTALLATION_INSTRUCTION_KEY: 'Lähetä asennusohjeet',
  SEND_TO_BACK_KEY: 'Siirrä taakse',
  SEND_KEY: 'Lähetä',
  SEND_TO_PRINT_TITLE_KEY: 'Send to print',
  SET_SIZE_KEY: 'Aseta koko',
  SETTINGS_KEY: 'Asetukset',
  SETTINGS_UPPERCASE_KEY: 'SETTINGS',
  SHARE_KEY: 'Jaa',
  SIGNED_IN_AS_KEY: 'Signed in as',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    'Sign in or register to see customized pricing and payment details',
  SIGN_UP_NOW_KEY: 'Sign up now',
  SKIP_KEY: 'Skip',
  SOLID_COLORS_KEY: 'Solid Colors',
  SQFT_UNIT_STRING_KEY: 'neliöjalkaa',
  SQM_UNIT_STRING_KEY: 'm²',
  START_TOUR_KEY: 'Start tour',
  STATUS_MSG: 'Your file has been sent to print!',
  SUBMIT_BUTTON_KEY: 'Lähetä',
  SHARE_LINK_LABEL: 'Valitse jaettavan linkin tyyppi',
  SHARE_EDIT_LINK: 'Muokkauslinkki',
  SHARE_VIEW_LINK: 'Katselulinkki',
  SHARE_YOUR_CREATION: 'Share your creation!',
  STREET_ADD: 'Street address',
  TARGET_VIEWING_HINT: '* Kohteen katseluetäisyyttä voi muuttaa asetuksista.',
  TERMS1_KEY: 'ehdot',
  TERMS2_KEY: 'HP:n tietosuojalauseke',
  TERMS3_KEY: 'HP:n ilmoitus henkilötietojen käsittelystä ja tietosuojasta',
  TERMS_OF_USE_KEY: 'Terms of use',
  TERMS_OF_USE: 'Käyttöehdot.',
  TEXT_SHADOW_COLOR_KEY: 'Text shadow Color',
  TEXT_UPPERCASE_KEY: 'TEXT',
  TILE_KEY: 'Laattojen asettelu',
  TOTAL_KEY: 'YHTEENSÄ',
  TOTAL_PRICE_KEY: 'Total:',
  TRANSPARENCY_KEY: 'Transparency',
  TEMPLATES_KEY: 'templates',
  TEMPLATES_UPPER_CASE_KEY: 'TEMPLATES',
  THANK_YOU_KEY: 'Kiitos',
  TWITTER_KEY: '  Twitter',
  UNLOCK_KEY: 'Poista lukitus',
  UNGROUP_KEY: 'Pura ryhmitys',
  UPDATE_TEXT_KEY: 'Päivitä',
  UPLOAD_KEY: 'Kuvan lataus',
  UPLOAD_LOGO_KEY: 'Upload logo',
  UPLOAD_IMAGE_KEY: 'Upload your own image',
  UPLOAD_UPPERCASE_KEY: 'UPLOAD',
  USER_NAME: 'Käyttäjänimi',
  USER_TYPE_TITLE_KEY: 'What type of user are you*',
  UNTILE_KEY: 'Asettelun poisto',
  UNSPLASH_SEARCH_TITLE: 'Unsplash Search',
  VALIDITY_KEY: 'Voimassaolo',
  VANILLA_LOGIN_DIALOG_KEY:
    'Join for free to save and print your design and see your saved work',
  VANILLA_PREVIEW_MESSAGE_KEY:
    'This is the preview of your design, check the design is final before proceeding or select edit to make any changes',
  VAT_KEY: 'ALV',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: 'vector',
  VIEW_FOTOLIA_KEY: 'Katsele Fotolia©ssa',
  VIEW_GETTY_IMAGE_KEY: 'View in Getty Image©',
  VIEW_I_STOCK_KEY: 'View in iStock©',
  VIEW_DESIGN_DETAILS_KEY: 'Näytä suunnitelman tiedot',
  VIEW_DESIGNER_PROFILE_KEY: 'Näytä suunnitteluohjelman profiili',
  VIEW_PRICE_KEY: 'Katso hinta',
  VECTEEZY_SEARCH_TITLE: 'Vecteezy Search',
  WALL_POSTER_KEY: 'Seinäjuliste',
  WALL_SIZE_TEXT_KEY: 'Wall size',
  WARNING_KEY: 'Varoitus',
  WEBSITE: 'Website',
  WIDTH_KEY: 'Leveys',
  YOU_CAN_ALWAYS_ACCESS: 'You can always access your designs in ',
  YOUR_NAME_KEY: 'Nimesi',
  YOUR_SELECTION_WILL_KEY:
    'Your selection will become your default printing path for future print outs.',
  YOUR_PROJECT_KEY: 'Projekti',
  PROJECT_NAME_ERROR_TEXT: 'Anna projektille nimi.',
  PROJECT_FOLDER_ERROR_TEXT: 'Anna projektikansiolle nimi.',
  PIXELATION_WARNING_SETTINGS_KEY: 'Pixel warning settings',
  MINIMUM_VIEWING_DISTANCE_KEY: 'Vähimmäiskatseluetäisyys',
  BACKGROUND_UPLOAD_KEY: ' background ',
  OBJECT_UPLOAD_KEY: ' object ',
  PHOTO_UPLOAD_KEY: ' photo ',
  NO_DREAMSTIME_ERROR_MESSAGE: 'Ei unelmakaania Sisältö löytynyt',
  NO_ELEMENT_ERROR_MESSAGE: 'Elementtejä ei löytynyt.',
  NO_MORE_IMAGES_FOUND_KEY: 'Kuvia ei löytynyt',
  NO_PATTERN_ERROR_MESSAGE: 'Kuvioita ei löytynyt.',
  TEXT_ANCHOR_MIDDLE: 'Center',
  TOUR_DESCRIPTION_TEXT:
    'Let us walk you through the design process. Remember you can re-open the tour at any time by clicking on the help icon.',

  ALREDY_HAVE_AN_ACCOUNT: 'Already have a {0} account?',
  CHANGE_MEASURING_SYSTEM_KEY: 'Change to {0}',
  DOWNLOADS_KEY: '{0} downloads',
  HEX_COLOR_KEY: 'Hex color: {0}',
  NEAR_KEY: 'Near',
  FAR_KEY: 'Far',
  CLOSE_UP_KEY: 'Close Up',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    'The images you are trying to use are either smaller or larger than the design area you are using.',
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    'To get better results use a {0} X {1} resolution image',
  MESSAGE_KEY: 'Viesti:',
  VIEWS_KEY: '{0} views',
  COST_DESCRIPTION_MESSAGE_KEY:
    'This is the summary of the cost related to the premium content included in your design. {0} By selecting finish you agree to be charged the following cost by the content providers.',
  DEFAULT_PRINTING_OPTION_KEY: '{0} is your default printing option,',
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: "Don't have a Dreamstime account yet?",
  REGISTER_PATTERNSUB2:
    ' you will revieve $100 worth of high-resolution images {0} to help with all your creative needs!',
  REGISTER_PATTERNSUB3:
    'Sign up today and over the course of the next 30 days, download creative files from our content base of 25 million photos, and see how {0} can help you meet your creative needs.',
  ZOOM_WARNING_PIXELATED_TEXT:
    'Olet skaalannut kuvan niin suureksi, että tulostettu kuva saattaa näyttää pikselöityneeltä, kun katseluetäisyys on {0} {1} * (nykyinen tulostustarkkuus on {2} dpi).',
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    'Suositeltu katseluetäisyys on {0} {1}. Jos se ei ole sopiva etäisyys, skaalaa tätä kuvaa tai seinäkuvaasi pienemmäksi.',
  ZOOM_WARNING_VALID_IMAGE_TEXT:
    'Kuvan suositeltu vähimmäiskoko on {0} x {1} pikseliä.',
  UPLOAD_STATUS: '{0}%/{1} Mt',
  REGISTER_TO: 'Register to {0}',
  MINIMUM_DIMENSIONS_KEY: 'Vähimmäismitat ovat {0} (l) x {1} (k).',
  MINIMUM_HEIGHT_KEY: 'Vähimmäiskorkeus on {0}.',
  MINIMUM_WIDTH_KEY: 'Vähimmäisleveys on {0}.',
  MAXIMUM_DIMENSIONS_KEY: 'Maximum dimensions are {0} (w) by {1} (h).',
  MAXIMUM_WIDTH_KEY: 'Enimmäisleveys on {0}',
  MAXIMUM_HEIGHT_KEY: 'Enimmäiskorkeus on {0}.',
  INVALID_NUMBER_ERROR_TEXT_KEY: 'Anna mitat nollaa suurempina numeroina.',
  PROCESSING_FAILED:
    'Käsittely epäonnistui, yritä uudelleen jonkin ajan kuluttua',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT:
    'Valitettavasti palvelumme ei tue salattuja PDF-tiedostoja.',
  DROPBOX_UPLOAD_PROGRESS_KEY: 'Tuodaan tiedostoa {0}/{1}',
  RECOLORING_KEY: 'Muutetaan värejä...',
  TEXT_COLOR_KEY: 'Text Color',
  SOLID_COLOR_KEY: 'Solid Color',
  AUTHENTICATE_DIALOG_TITLE: 'Sisällön lähde on suojattu salasanalla',
  AUTHENTICATE_FAILED_MESSAGE: 'Todennus epäonnistui!',
  DROPBOX_IMPORT_ERROR_HEADER:
    'Joidenkin tiedostojen tuomisessa ilmeni ongelmia',

  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT: 'Monisivuisia PDF-tiedostoja ei tueta.',
  HP_FEEDBACK_TEXT: 'HP wants your feedback',
  FEEDBACK_QUERY_TEXT: 'Overall, how satisfied are you with our solutions?',
  VERY_SATISFIED_BUTTON_TEXT: 'Very Satisfied',
  SATISFIED_BUTTON_TEXT: 'Satisfied',
  DISSATISFIED_BUTTON_TEXT: 'Dissatisfied',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Very Dissatisfied',
  FEEDBACK_IMPROVE_TEXT: 'What can we do to improve?',
  FEEDBACK_PRIVACY_INFO_TEXT: 'Privacy Statement',
  FEEDBACK_PLACEHOLDER_TEXT:
    "We review your feedback to improve our products, so please don't share any personal data or confidential/propreitary content",
  DEFAULT_PROJECT_NAME: 'Project',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: 'Valitse kannettava tietokoneesi',
  SHOW_ALL_KEY: 'Show all',
  Go_BACK_KEY: ' Go back',
  FIRST_NAME_KEY: 'Etunimi',
  LAST_NAME_KEY: 'Sukunimi',
  PHONE_NUMBER_KEY: 'Puhelinnumero',
  POSTAL_ADDRESS: 'Postal address',
  COMPANY_NAME: 'Company name',
  INVALID_PHONE_NUMBER_KEY: 'Virheellinen puhelinnumero',
  INVALID_POSTAL_ADDRESS: 'Invalid Postal address',
  INVALID_COMPANY_NAME: 'Invalid Comapany name',
  TERMS_AND_CONDITIONS: 'Hyväksyn käyttöehdot',
  INVOICE_UPLOAD: 'Upload Invoice',
  INVOICE_FILE_MISSING: 'Invoice file missing',
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* You can find detailed information about HP’s data collection principles on HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'Hyväksyn, että henkilötietoni jaetaan HP:n kanssa, jotta minuun voidaan ottaa yhteyttä tulevista HP:n kampanjoista.*',
  SERVICE_PROVIDER_CONDITION:
    'Hyväksyn, että antamani tiedot saatetaan jakaa palvelutoimittajien kanssa tulostusta ja toimitusta varten.*',
  ORDER_DESIGN: 'Tilaa kuvio',
  SUBMIT_YOUR_DESIGN: 'Lähetä kuviosi',
  SUBMISSION_DESIGN_ORDER: 'Kuviotilauksen lähetys',
  ENTER_REQUIRED_FIELDS_KEY: 'Kirjoita pakollisiin kenttiin',
  ADDRESS_KEY: 'Osoite',
  INVALID_ADDRESS_KEY: 'Virheellinen osoite',
  CITY_KEY: 'Paikkakunta',
  INVALID_CITY_KEY: 'Virheellinen paikkakunta',
  COUNTRY_KEY: 'Maa',
  STATE_KEY: 'Osavaltio',
  ZIP_KEY: 'Postinumero',
  INVALID_ZIP_KEY: 'Virheellinen postinumero',
  ORDER_NUMBER: 'Tilausnumero',
  YOUR_DETAILS_KEY: 'Sinun yksityiskohtasi',
  APPLY_DESIGN_COMPETITION: 'Osallistu suunnittelukilpailuun',
  NOTICE_KEY: 'Ilmoitus:',
  CAUTION_FOR_LAPTOP_SELECTION:
    'Jos sinulla on PC-iho, joka sopii täydellisesti sinun omaan, sinun on valittava tarkka malli, joka vastaa kauppaa, kuten se näkyy laskussa.',
  RESTART_PROJECT_ALERT_TITLE: 'Aloitetaanko suunnitelma alusta?',
  DISCARD_ALERT_MESSAGE: 'Nykyinen suunnitelmasi hylätään.',
  RESTART: 'Aloita alusta',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE: 'Sivukoko Varoitus!',
  INSPIRATION_SIZE_CHANGE_WARNING:
    'Tämän inspiraatiomallin oletuskoko on {0} X {1} {2}. Sivusi koko muuttuu automaattisesti sopimaan tähän malliin.',
  MODIFY_SIZE_WARNING:
    'Jos haluat muuttaa tämän mallin kokoa, voit tehdä sen “Asetukset” -välilehdessä. Suunnitteluelementit saattavat edellyttää muokkaamista, jotta ne voidaan säätää haluamiesi mittojen mukaan.',
  RANDOMIZE_KEY: 'Satunnainen',
  MATERIAL_CHOICE_APPLIED: 'Materiaalivalinta on sovellettu.',
  FEEDBACK_PERMISSION_STRING_KEY:
    'I grant permission to HP to contact me about my feedback',
  BLOCKCHAIN_STRING: 'Lohkoketju',
  CERTIFICATE_STRING: 'todiste:',
  AUTHENTICITY_STRING: 'todenperäisyys',
  PLEASE_WAIT: 'Odota',
  PROTECTING_YOUR_DATA: 'suojaa tietosi...',
  SEARCH_YOUR_LAPTOP_KEY: 'Hae kannettavasta tietokoneesta', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY:
    'Oho! Emme löytäneet kannettavia tietokoneita hakuasi varten.', // Google translated

  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',
  SERIAL_NUMBER_KEY: 'Sarjanumero',
  LOCKED_PROJECT: 'Lukittu suunnitelma',
  LOCKED_MESSAGE:
    'Tämä suunnitelma on tilattu eikä sitä voi muuttaa. Sitä voi vain katsoa.',
  EXPIRED_PROJECT: 'Vanhentunut suunnitelma',
  EXPIRED_MESSAGE: 'Tämä suunnitelma on vanhentunut.',
  DELETED_PROJECT: 'Poistettu suunnitelma',
  DELETED_MESSAGE: 'Tämä suunnitelma on poistettu.',
  CHOOSE_GROUP_TYPE: 'Valitse {0}tyyppi',

  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: 'Anna nollaa suurempia numeroita.',
  SIZE_KEY: 'Koko',
  DISTANCE_FROM_KEY: 'Etäisyys kohteesta',
  MYROOM_UPPERCASE_KEY: 'MY ROOM',
  FURNITURE_KEY: 'Furniture',
  FIXTURES_KEY: 'Fixtures',
  ADD_A_WALL_KEY: 'Add a wall',
  SELECT_A_WALL_KEY: 'Select a Wall',
  LEFT_KEY: 'Vasen',
  RIGHT_KEY: 'Oikea',
  DELETE_WALL_KEY: 'Delete a wall',
  // CANVAS
  CHOOSE_CANVAS_TYPE_KEY: 'Choose canvas type',
  MAXIMUM_WALL_SIZE_KEY: 'Seinän enimmäiskoko on {0} {1}².',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY: 'Kankaan korkeus ylittää seinän korkeuden.',
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY: 'Kankaan leveys ylittää seinän leveyden.',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY:
    'Nykyisen leveyden enimmäissarakemäärä on {0}',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY: 'Nykyisen korkeuden enimmäisrivimäärä on {0}',
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY:
    'Seinän leveys on pienempi kuin kankaan leveys.',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY:
    'Seinän leveyden on oltava vähintään {0} {1}.',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY:
    'Seinän korkeuden on oltava vähintään {0} {1}.',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    'Seinän korkeus on pienempi kuin kankaan korkeus.',
  MAXIMUM_WALL_HEIGHT_KEY: 'Seinän enimmäiskorkeus on {0} {1}.',
  FINISHING_KEY: 'Finishing',
  MIRROR_KEY: 'Mirror',
  NATURAL_KEY: 'Natural',
  ROWS_KEY: 'Rivit',
  COLUMNS_KEY: 'Sarakkeet',
  DEFAULT_WALL_SIZE_KEY: 'Default Wall Size',
  EDIT_KEY: 'Muokkaa',
  TOP_KEY: 'Ylin',
  BOTTOM_KEY: 'Alin'
};
